// removed by extract-text-webpack-plugin
module.exports = {"container":"_24wLZxpNIl0L4hPPdX6Rr7","title":"_2oIAQPuSrwaXtyG8xSV3cO"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Admin/UserInformation/UserOrganizations/styles.css
// module id = 3174
// module chunks = 0